<template>
    <vue-highcharts :highcharts="Highcharts" :options="options" ref="lineCharts"></vue-highcharts>        
</template>

<script>
    import VueHighcharts from "vue2-highcharts";
    // import Exporting from "highcharts/modules/exporting";
    import Highcharts from "highcharts";

    import moment from 'moment'
    import MomentTimeZone from "moment-timezone";

    // Exporting(Highcharts);
    export default {
        props: ['settings', 'values', 'redraw'],

        components: {VueHighcharts},

        data() {
            return {
                options: {},
                Highcharts,
            };
        },

        created() {
            this.options = this.settings;

            window.moment = moment
            MomentTimeZone();
            
            if(this.values)
                this.load();
        },

        watch: {
            values() {
                this.load();
            },
            redraw() {
                
            }
        },

        methods: {
            load(){
                if(this.$refs.lineCharts == undefined)
                    return;
            
                let lineCharts = this.$refs.lineCharts;

                var timezone = moment.tz.guess();
                
                Highcharts.setOptions({
                    time: {
                        timezone: timezone
                    }
                }); 

                for (let key in this.values) {
                    lineCharts.addSeries(this.values[key]);

                    // if(this.settings.chart.type == 'column' && this.values.series[key]['categories'] != undefined)
                    //     lineCharts.getChart().xAxis[0].setCategories(this.values.series[key]['categories']);
                }
            },
        }
    }
</script>